<template>
  <div :class="cardClasses">
    <div class="product-card">
      <!-- Header -->
      <div class="product-card__header">
        <div class="product-card__title-wrapper">
          <h4 class="product-card__title">{{ productItem.plan.name ? productItem.plan.name : productItem.custom_text }}</h4>
          <span class="product-card__type-badge">{{ productType }}</span>
        </div>
        <!-- <div class="product-card__actions">
          <a v-if="isPaid(productItem.payment_status) && existenDatosCliente(item)"
             @click="generateInvoice()"
             class="product-card__invoice-btn pointer"
             v-c-tooltip.hover="'Descargar factura'">
            <i class="fa fa-download" aria-hidden="true"></i>
            <span>Factura</span>
          </a>
          <a v-else-if="isPaid(productItem.payment_status) && !existenDatosCliente(item)"
             @click="$emit('showInvoiceAlert', true)"
             class="product-card__invoice-btn product-card__invoice-btn--warning pointer"
             v-c-tooltip.hover="'Completa tus datos de facturación'">
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
            <span>Factura</span>
          </a>
          <BadgePaymentStatus v-else :badgetText="false" :attribute="productItem.payment_status" :classBadge="'status-list'"></BadgePaymentStatus>
        </div> -->


        <div class="product-card__actions">
          <a v-if="isPaid(productItem.payment_status) && existenDatosCliente(item)"
             @click="generateInvoice()"
             class="product-card__invoice-link pointer">
            <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
            <span class="product-card__invoice-text">Descargar factura</span>
          </a>
          <a v-else-if="isPaid(productItem.payment_status) && !existenDatosCliente(item)"
             @click="$emit('showInvoiceAlert', true)"
             class="product-card__invoice-link product-card__invoice-link--disabled pointer">
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
            <span class="product-card__invoice-text">Completar datos</span>
          </a>
          <BadgePaymentStatus v-else :badgetText="false" :attribute="productItem.payment_status" :classBadge="'status-list'"></BadgePaymentStatus>
        </div>
      </div>

      <!-- Content -->
      <div class="product-card__content">
        <div class="product-card__info-row">
          <CIcon name="cil-location-pin" height="16" class="product-card__icon" />
          <span class="product-card__parking-name">{{ productItem.parking.name }}</span>
        </div>
        <div class="product-card__info-row">
          <CIcon name="cil-calendar" height="16" class="product-card__icon" />
          <span class="product-card__dates">{{ item.start_datetime | DateTimeDMYhms }} - {{ item.end_datetime | DateTimeDMYhms }}</span>
        </div>
      </div>

      <!-- Footer -->
      <div class="product-card__footer">
        <div class="product-card__footer-left">
          <span v-if="productItem.plans_id === 10" class="product-card__renewal">
            <CSwitch class="product-card__switch"
              v-c-tooltip.hover.click="'Renovación automática'"
              color="primary"
              variant="3d"
              size="sm"
              name="renew"
              shape="square"
              :checked="productItem.renewal ? productItem.renewal : false"
              v-bind="labelIcon"
              :value="productItem"
              :disabled="productItem.status == 'FINISHED'"
              @update:checked="() => toggleRenewal(productItem)"
            />
            <small class="product-card__renewal-label">Auto-renovar</small>
          </span>
          <CButton @click="gotToDetail" color="light" size="sm" class="product-card__detail-btn">Ver detalle</CButton>
        </div>
        <div class="product-card__price">
          <span class="product-card__price-amount">{{ (productItem.total_amount).toFixed(2) }} €</span>
          <small class="product-card__price-vat">IVA incl.</small>
        </div>
      </div>

      <spinner-ttt :show="loadingCard"></spinner-ttt>
    </div>

    <spinner-circle :show="loading"></spinner-circle>
    <toast ref="toast"></toast>
  </div>
</template>

<script>
import stringUtils from "@/app/shared/utils/stringUtils";
import {LABEL_ICON, PAYMENT_PAID } from '@/config';

import  { generateInvoice, fetchOnePayment } from '@/app/shared/global/services/payment-service';
import { getInvoice, fetchOneInvoice } from "@/app/shared/global/services";

import BadgePaymentStatus from '@/components/badges/BadgePaymentStatus';

export default {
  name: 'product-card',
  components: { BadgePaymentStatus },
  props: {
    title: String,
    loading: { type: Boolean, default: true  },
    item: { type: Object, default: {}, required: true },
    cardClasses: { type: String, default: ''},
    plansCount: { type: Number, default: 1},
  },
  data(){
    return {
      stringUtils: stringUtils,
      labelIcon: LABEL_ICON,
      PAYMENT_PAID: PAYMENT_PAID,
      loadingCard: false,
      paymentCardProduct: null
    }
  },
  created() { },
  computed: {
    productItem: function () {
      return {...this.item}
    },
    renewalPlan() {
      return this.item.renewal
    },
    productType() {
      return this.productItem.product_type === 'custom' ? 'Personalizado' : 'Prepago';
    },
    paymentInvoiceID() {
      return this.productItem.payments[0]?.payment?.invoices_id;
    },

  },
  watch: {
    renewalPlan(newVal, oldVal) {
      this.$emit('toggle-renewal-plan', newVal);
    }
  },
  methods: {
    toggleRenewal(product) {
      this.$emit('toggle-renewal', product)
    },
    gotToDetail(){

      const productType = this.productItem.product_type === 'custom' ? 'custom' : 'prepago';

      this.$router.push({path: `/gestion/contrataciones/${this.productItem.id}` , query: {data:`${productType}`} });
    },

    getStatusColor(status) {
      return status === 'ACTIVE' ? 'success'
        : status === 'CANCELLED' ? 'danger'
          : status === 'FINISHED' ? 'warning' : 'light'

    },

    changeRenewalPlan(value) {
      this.$emit('toggle-renewal', !value)
    },

    getProductPayment(payments) {
      const paymentProduct = payments.find(p => p.payment.status === 'PAID');
      return paymentProduct?.payment;
    },

    isActive(value){
      return !["FINISHED", "CANCELLED", "NOT_ACTIVE"].includes(value)
    },

    isPaid(value) {
      return value  == PAYMENT_PAID.key;
    },


    async generateInvoice(){

      try {

        this.loadingCard = true;

        const payment = this.getProductPayment(this.productItem.payments);

        // Descargar la factura ya generada
        if (this.paymentInvoiceID) {

          // get invoice
          // let data = await this.getPayment(payment.id);
          let resp = await fetchOneInvoice(this.paymentInvoiceID);

          if (resp.status !== "success") {
            this.$refs.toast.showToast(`Se ha producido un error al obtener el archivo`,null,"error","5000");
            this.loadingCard = false;
            return;
          }

          this.downloadInvoice(resp.data);

          return;
        }


        const invoice = await generateInvoice(payment.id);

        if(!invoice) {
          this.$refs.toast.showToast(`Se ha producido un error al obtener el archivo`,null,"error","5000");
          return
        }

        this.$emit('updateData');

        this.downloadInvoice(invoice.data);

      }catch(e) {
        console.error(e);
        this.$refs.toast.showToast(`Error en la descarga de factura`, null, 'error', '2000');

      } finally {
        this.loadingCard = false;
      }

    },

    existenDatosCliente(product){
      return product?.payments[0]?.payment ? product?.client?.has_billing_info : false;
    },

    async downloadInvoice(invoice){

      try {
        const response = await getInvoice(invoice).catch(e => {
          resetResponseType();
          this.$refs.toast.showToast(`Error en la descarga de factura`, null, 'error', '2000');
        });

        if (response) {
          this.downloadInvoicePdf(response, invoice);
        }
      }catch(e) {
         console.error(e);
        // this.$refs.toast.showToast(`Error en la descarga de factura`, null, 'error', '2000');
      }

    },
    async getPayment(paymentId) {

      try {

        let resp = await fetchOnePayment(paymentId);

        if (resp.status !== "success") {
          this.$refs.toast.showToast(`Se ha producido un error al cargar`,null,"error","5000");
          return;
        }

        return resp.data;

      } catch (e) {
        this.$refs.toast.showToast(`Se ha producido un error al cargar`,null,"error","5000");
      }
    },


    downloadInvoicePdf(response, invoice) {

      const file = new Blob([response.data], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      const link = document.createElement('a');
      link.href = fileURL;


      link.setAttribute('download', invoice.reference + '' );
      document.body.appendChild(link);
      link.click();

      this.$refs.toast.showToast('Factura descargada con éxito', null, 'success', '2000');

      document.body.removeChild(link);
    },
  }


}
</script>

<style lang="scss" scoped>
.product-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  padding: 16px;
  position: relative;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 12px;
  }

  &__title-wrapper {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  &__title {
    font-size: 16px;
    font-weight: 700;
    color: #1a202c;
    margin: 0;
    line-height: 1.3;
  }

  &__type-badge {
    display: inline-block;
    font-size: 10px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: #667eea;
    background: #eef2ff;
    padding: 2px 8px;
    border-radius: 4px;
  }

  &__actions {
    flex-shrink: 0;
    margin-left: 12px;
  }

  &__invoice-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 6px;
    color: #718096;
    font-size: 14px;
    text-decoration: none;
    transition: all 0.2s ease;

    &:hover {
      color: #2e7d32;
      background: #e8f5e9;

      .product-card__invoice-text {
        max-width: 150px;
        opacity: 1;
        margin-left: 6px;
      }
    }

    &--disabled {
      color: #e65100;

      &:hover {
        color: #e65100;
        background: #fff3e0;
      }
    }
  }

  &__invoice-text {
    font-size: 12px;
    font-weight: 500;
    max-width: 0;
    opacity: 0;
    overflow: hidden;
    white-space: nowrap;
    transition: all 0.3s ease;
  }

  &__content {
    margin-bottom: 12px;
  }

  &__info-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__icon {
    color: #718096;
    flex-shrink: 0;
  }

  &__parking-name {
    font-size: 13px;
    font-weight: 500;
    color: #4a5568;
  }

  &__dates {
    font-size: 12px;
    color: #718096;
  }

  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 12px;
    border-top: 1px solid #edf2f7;
  }

  &__footer-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  &__renewal {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  &__switch {
    transform: scale(0.85);
  }

  &__renewal-label {
    font-size: 11px;
    color: #718096;
  }

  &__detail-btn {
    font-size: 12px;
    padding: 4px 12px;
    border-radius: 6px;
    font-weight: 500;
  }

  &__price {
    text-align: right;
  }

  &__price-amount {
    display: block;
    font-size: 18px;
    font-weight: 700;
    color: #2d3748;
    line-height: 1.2;
  }

  &__price-vat {
    font-size: 10px;
    color: #a0aec0;
  }
}
</style>
